import type { SVGProps } from "react";
export default function SvgForward(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-forward-icon lucide-forward"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="m15 17 5-5-5-5" />
			<path d="M4 18v-2a4 4 0 0 1 4-4h12" />
		</svg>
	);
}
